import { memo } from 'react';

type SvgProps = React.ComponentPropsWithoutRef<'svg'>;

export const ColumnsIcon = memo(({ className, ...props }: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Left column */}
      <rect x="3" y="3" width="7.5" height="18" rx="1" />
      {/* Right column */}
      <rect x="13.5" y="3" width="7.5" height="18" rx="1" />
    </svg>
  );
});

ColumnsIcon.displayName = 'ColumnsIcon';
